module.exports = __webpack_public_path__ + "static/img/plan_category_room_upgrade.6b2743f7.png";